import script from "./BaseChip.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChip.vue?vue&type=script&setup=true&lang=js"

import "./BaseChip.vue?vue&type=style&index=0&id=0b8b4af5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8b4af5"]])

export default __exports__